import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, FileUploadFor, LocalService, LookupType, PageKey, Status, TriggeredEvent, Wrappers10 } from 'src/service/local.service';
import { LookupService } from 'src/service/lookup.service';

@Component({
  selector: 'app-lookups',
  templateUrl: './lookups.component.html',
  styleUrl: './lookups.component.scss'
})
export class LookupsComponent {
  LookupType = LookupType; FileUploadFor = FileUploadFor; selectedLanguage = ''; isOpenLanguageSelection = false;
  lstSectionConfigKeys: string[] = ["common", "table", "lookup"];
  ctryCode: string = ''; lookupType: LookupType = LookupType.None; interactionType = 0; maxBodyHeight = 0;
  source: Wrappers10; isOpenLookup = false; selectedLookupId: string = ''; isOpenConfirmationBox = false;
  isShowInActive: boolean = false; selectedLookUpName: string = '';
  htmlId: string = ''; elementIds: any;

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private lookupService: LookupService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      file: 'file' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.lookupType = parseInt(routeParams.type);
      this.configurationManagementService.ensurePageActions(PageKey.Lookups);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
      this.ctryCode = routeParams.ctryCode;
      this.onInitiate();
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.setLookUpName();
  }

  setLookUpName() {
    if (this.lookupType != LookupType.None && this.localService.lookupTypes.length > 0) {
      const item = this.localService.lookupTypes.find(x => x.key == this.lookupType.toString());
      this.selectedLookUpName = item ? item.value : '-';
    }
  }

  onLoad() {
    if (this.lookupType != LookupType.None) {
      this.lookupService.getLookups(this.lookupType, this.source && this.source.paging ? this.source.paging : undefined, !this.isShowInActive).subscribe(result => {
        this.source = result;
      });
    }
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.selectedLookupId = key;
        this.isOpenLookup = true;
      } break;
      case 2: {
        this.selectedLookupId = key;
        this.isOpenConfirmationBox = true;
      } break;
      case 3: {
        this.isOpenLanguageSelection = true;
      } break;
    }
  }

  onLanguageSelected(result: any) {
    if (result && result.event == TriggeredEvent.Ok) {
      this.selectedLanguage = result.data;
      let element = document.getElementById(this.elementIds.file) as HTMLElement;
      if (element)
        element.click();
    }
  }

  onDelete(result: any) {
    this.isOpenConfirmationBox = false;
    if (result && result.event == TriggeredEvent.Ok) {
      if (this.lookupType != LookupType.None) {
        if (this.selectedLookupId) {
          this.lookupService.deleteLookup(this.selectedLookupId, this.lookupType, !this.isShowInActive).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onLoad();
            }
          });
        } else {
          this.lookupService.deleteLookups(this.lookupType, !this.isShowInActive, this.source && this.source.paging ? this.source.paging : undefined).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onLoad();
            }
          });
        }
      }
    }
  }

  onActiveInactiveStatus(key: string) {
    this.lookupService.activeInactiveStatus(key, ActiveInactiveFor.Lookup).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        let item = this.source.items.find(x => x.key == key);
        if (item) {
          item.v4 = item.v4 == '1' ? '0' : '1';
        }
      }
    });
  }
}
